module.exports = __webpack_public_path__ + "static/index/img/baikal-1007.cb9f79b0.jpg";